import moment from "moment-timezone";

// State to timezone mapping - matches server-side
const STATE_TIMEZONE_MAP = {
	IL: "America/Chicago", // Illinois - Central Time
	CA: "America/Los_Angeles", // California - Pacific Time
	NY: "America/New_York", // New York - Eastern Time
	TX: "America/Chicago", // Texas - Central Time (most of it)
	FL: "America/New_York", // Florida - Eastern Time
	CO: "America/Denver", // Colorado - Mountain Time
	// Add more states as needed
};

// Get timezone from location data (client-side)
export const getTimezoneFromLocationData = (locationData) => {
	if (!locationData || !locationData.state) {
		console.warn(
			`Location data missing or no state provided, defaulting to America/Chicago`
		);
		return "America/Chicago"; // Default fallback
	}

	const timezone = STATE_TIMEZONE_MAP[locationData.state.toUpperCase()];
	if (!timezone) {
		console.warn(
			`No timezone mapping for state ${locationData.state}, defaulting to America/Chicago`
		);
		return "America/Chicago"; // Default fallback
	}

	return timezone;
};

// Get timezone for a location (client-side) - legacy function for backward compatibility
const getTimezoneForLocation = (locationId) => {
	// Default to Central Time for now
	// TODO: Could be enhanced to lookup by locationId via API
	return "America/Chicago";
};

export const formatTime = (seconds) => {
	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = seconds % 60;
	return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
};

export const dateToTime = (date, location) => {
	return moment(date).format("hh:mma");
};

export const checkPastTime = (time, locationIdOrData) => {
	let timezone;

	// Check if locationIdOrData is an object (location data) or string (locationId)
	if (locationIdOrData && typeof locationIdOrData === "object") {
		// It's location data
		timezone = getTimezoneFromLocationData(locationIdOrData);
	} else {
		// It's a locationId or null
		timezone = getTimezoneForLocation(locationIdOrData);
	}

	return moment(time).tz(timezone).isBefore(moment().tz(timezone));
};

// Check if current time is within the allowed unlock window
export const isWithinUnlockWindow = (
	startTime,
	endTime,
	locationIdOrData = null
) => {
	let timezone;

	// Check if locationIdOrData is an object (location data) or string (locationId)
	if (locationIdOrData && typeof locationIdOrData === "object") {
		// It's location data
		timezone = getTimezoneFromLocationData(locationIdOrData);
		console.log(
			"🕐 Using location data for timezone:",
			locationIdOrData.state,
			"→",
			timezone
		);
	} else {
		// It's a locationId or null
		timezone = getTimezoneForLocation(locationIdOrData);
		console.log(
			"🕐 Using default timezone for locationId:",
			locationIdOrData,
			"→",
			timezone
		);
	}

	const now = moment().tz(timezone);
	const start = moment.tz(startTime, timezone);
	const end = moment.tz(endTime, timezone);

	const allowedStartTime = start.clone();

	console.log("🕐 Unlock window check:");
	console.log("  Your local time:", moment().format("YYYY-MM-DD HH:mm:ss z"));
	console.log(
		"  Current time in location timezone:",
		now.format("YYYY-MM-DD HH:mm:ss z")
	);
	console.log("  Start time:", start.format("YYYY-MM-DD HH:mm:ss z"));
	console.log("  End time:", end.format("YYYY-MM-DD HH:mm:ss z"));
	console.log("  Raw startTime from server:", startTime);
	console.log("  Raw endTime from server:", endTime);
	console.log(
		"  Can unlock?",
		now.isBetween(allowedStartTime, end, null, "[]")
	);

	return now.isBetween(allowedStartTime, end, null, "[]");
};

// Get time until unlock is available
export const getTimeUntilUnlock = (startTime, locationIdOrData = null) => {
	let timezone;

	// Check if locationIdOrData is an object (location data) or string (locationId)
	if (locationIdOrData && typeof locationIdOrData === "object") {
		// It's location data
		timezone = getTimezoneFromLocationData(locationIdOrData);
		console.log(
			"🕐 Using location data for timezone:",
			locationIdOrData.state,
			"→",
			timezone
		);
	} else {
		// It's a locationId or null
		timezone = getTimezoneForLocation(locationIdOrData);
		console.log(
			"🕐 Using default timezone for locationId:",
			locationIdOrData,
			"→",
			timezone
		);
	}

	const now = moment().tz(timezone);
	const start = moment.tz(startTime, timezone);
	const allowedStartTime = start.clone();

	if (now.isBefore(allowedStartTime)) {
		const diff = moment.duration(allowedStartTime.diff(now));
		const hours = Math.floor(diff.asHours());
		const minutes = diff.minutes();

		if (hours > 0) {
			return `${hours}h ${minutes}m`;
		}
		return `${minutes}m`;
	}

	return null;
};
